import { render, staticRenderFns } from "./NotaDeIngreso.vue?vue&type=template&id=46c5756c&scoped=true&"
import script from "./NotaDeIngreso.vue?vue&type=script&lang=js&"
export * from "./NotaDeIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5756c",
  null
  
)

export default component.exports